import { portalFragmentPermissionGroupsSettingsSource, blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostNameTenant, messaginghubWebsocketHostName } from 'app.constants';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
export class PermissionGroupsController {
    static $inject = ['LoadingService', 'TranslateService', 'AccountService2', 'AuthenticationService', 'TenantService'];
    constructor(LoadingService, TranslateService, AccountService2, AuthenticationService, TenantService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.AuthenticationService = AuthenticationService;
        this.TenantService = TenantService;
        this.settingsSource = portalFragmentPermissionGroupsSettingsSource;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.checkTenantContext = (ContextProcessorService) => {
            this.currentTenantId = ContextProcessorService.getTenantPrefixFromUrl();
        };
        this.checkTenantContext(TenantService);
        this.user = this.AccountService2.meSync();
        this.language = this.TranslateService.getCurrentLanguage();
        this.webSocketParams = {
            blipDomainUrl,
            blipWebsocketHostName,
            blipWebsocketHostNameTenant,
        };
        this.LoadingService.stopLoading();
    }
    async $onInit() {
        this.language = this.TranslateService.getCurrentLanguage();
        this.token = this.AuthenticationService.token;
        this.authEmail = this.AuthenticationService.email;
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
    }
}
PermissionGroupsController.$inject = ['LoadingService', 'TranslateService', 'AccountService2', 'AuthenticationService', 'TenantService'];
